import { SelectInputField } from './select-input-field';
import { SelectOptions } from 'ts-types';

const TITLE_OPTIONS: SelectOptions<string, string>[] = [
  { value: 'Mr', label: 'Mr' },
  { value: 'Mrs', label: 'Mrs' },
  { value: 'Ms', label: 'Ms' },
  { value: 'Miss', label: 'Miss' },
  { value: 'Dr', label: 'Dr' },
  { value: 'Prof', label: 'Prof' },
  { value: 'Rev', label: 'Rev' }
];

type TitleSelectProps = {
  name: string;
  label?: string;
  required?: boolean;
  isSmallSize?: boolean;
};

export const TitleSelect = ({ name, label = 'Title', required, isSmallSize = true }: TitleSelectProps) => {
  return (
    <SelectInputField name={name} label={label} values={TITLE_OPTIONS} required={required} isSmallSize={isSmallSize} />
  );
};
